export const productTypes = {
  1: 't-shirt',
  2: 'review',
  3: 'winstrike',
  4: 'tourney',
  5: 'blast',
}
